import { Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { AuthorCard } from "./AuthorCard";
import { ArrowRight } from "lucide-react";

interface AuthorBioProps {
  author: {
    id: string;
    full_name: string | null;
    avatar_url: string | null;
    bio: string | null;
    job_title: string | null;
    expertise_areas: string[] | null;
    linkedin_url: string | null;
    twitter_url: string | null;
    website_url: string | null;
    author_slug: string | null;
  };
}

export const AuthorBio = ({ author }: AuthorBioProps) => {
  const authorName = author.full_name || "iQ Team";

  return (
    <Card className="mt-12">
      <CardContent className="pt-6">
        <h3 className="text-lg font-semibold mb-4">About the Author</h3>
        <AuthorCard author={author} showBio={true} showExpertise={true} showSocial={true} />
        
        {author.author_slug && (
          <Link
            to={`/blog/author/${author.author_slug}`}
            className="inline-flex items-center gap-1 text-sm text-primary hover:underline mt-4"
          >
            More from {authorName}
            <ArrowRight className="h-4 w-4" />
          </Link>
        )}
      </CardContent>
    </Card>
  );
};
